/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { createContext, useContext } from "react";
import { TInspectorNode } from "../../InspectorNodeTypes";

export interface IExpandedNodesStateItem {
	node: TInspectorNode;
	offset: number;
}

export interface IInspectorNodeListContext {
	expandedNodes: IExpandedNodesStateItem[];
	depth: number;
	toggleExpandedNode: (depth: number, itemNode: IExpandedNodesStateItem) => void;
	setExpandedNodes: (nodes: IExpandedNodesStateItem[]) => void;
}

export const InspectorNodeListContext = createContext<IInspectorNodeListContext>(null);

export function useInspectorNodeListContext(): IInspectorNodeListContext {
	return useContext(InspectorNodeListContext);
}
